import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ArrowIcon({ className, size = 20, direction, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, direction, className }))}
      {...props}
    >
      <g className="origin-center [transform-box:fill-box]" data-direction>
        <path
          d="M14.2803 12.2803C14.421 12.1397 14.5 11.9489 14.5 11.75C14.5 11.5511 14.421 11.3603 14.2803 11.2197L10.2803 7.2197C9.98743 6.9268 9.5126 6.9268 9.2197 7.2197C8.9268 7.5126 8.9268 7.9874 9.2197 8.2803L12.6893 11.75L9.2197 15.2197C8.9268 15.5126 8.9268 15.9874 9.2197 16.2803C9.5126 16.5732 9.98744 16.5732 10.2803 16.2803L14.2803 12.2803Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowExpandedIcon({ className, size = 20, direction, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, direction, className }))}
      {...props}
    >
      <g className="origin-center [transform-box:fill-box]" data-direction>
        <path
          d="M17.4697 14.4697C17.1768 14.7626 17.1768 15.2374 17.4697 15.5303C17.7626 15.8232 18.2374 15.8232 18.5303 15.5303L21.5283 12.5324C21.535 12.5257 21.5416 12.5189 21.5481 12.5119C21.6734 12.3779 21.75 12.1979 21.75 12C21.75 11.8994 21.7302 11.8034 21.6943 11.7158C21.6577 11.6262 21.603 11.5423 21.5303 11.4697L18.5303 8.4697C18.2374 8.1768 17.7626 8.1768 17.4697 8.4697C17.1768 8.7626 17.1768 9.2374 17.4697 9.5303L19.1894 11.25L3 11.25C2.5858 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.5858 12.75 3 12.75L19.1893 12.75L17.4697 14.4697Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
